import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormFieldService } from '../../services/form-field.service';
import { FormChipsField } from './form-chips.model';

@Component({
  selector: 'gio-form-chips',
  templateUrl: './form-chips.component.html',
  styleUrls: ['./form-chips.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class FormChipsComponent<N = any> extends FormBaseComponent<FormChipsField<N>> {

  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  options: string[] = [];

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    this.subscribe = this.group.valueChanges.subscribe(values => {
      this.options = values[this.field.name] ?? []
    });
  }

  onComponentDestroy() { }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.options.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.updateForm();
  }

  remove(item: string): void {
    this.options.remove(item);
    this.updateForm();
  }

  updateForm() {
    const a: any = {};
    a[this.field.name] = this.options;
    this.group.patchValue(a);
  }

}
